module.exports = __webpack_public_path__ + "static/media/Product_Photos_Cakes.51a01ffd.png";